import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRouteVacancies } from "../../../../shared/constants/routes";
import { Container, IconButton } from "../../../../shared/ui";
import { generateMediaQuery } from "../../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";
import styles from "./SearchButton.module.scss";
import { useDebouncedCallback } from "../../../../shared/hooks/useDebouncedCallback";

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm);

export const SearchButton: FC = () => {
    const isMobile = useMediaQuery(mediaQuery);
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [showButton, setShowButton] = useState(false);

    const handleScroll = useDebouncedCallback(() => {
        if (window.scrollY > 400) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    }, 100);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll]);

    const handleClick = () => {
        if (pathname === getRouteVacancies()) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        } else {
            navigate(getRouteVacancies());
        }
    };

    return isMobile && showButton ? (
        <div className={styles.wrapper}>
            <Container marginSize="standard">
                <IconButton className={styles.button} icon="searchButton" onClick={handleClick} />
            </Container>
        </div>
    ) : null;
};
